<template>
  <b-container class="mw-100 mt-3">
    <b-card class="mt-4 mb-4" :body-class="isMobile ? 'p-2' : ''">
      <standard-table ref="vehicleTable"
                      :items="items"
                      :fields="fields"
                      :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 8, xl: 8, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                      :before-pagination="{cols: 12, sm: 12, md: 12, lg: 12, xl: 12}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"
                      :customFields="customFields"

                      :search-label-horizontal="false"
                      fullWidth="true"
                      noContainerPadding="true"

                      @rowEdit="pushToEdit($event.item)">

        <div slot="test" slot-scope="row">
          <i v-if="row.item.infoStatus === 'Undefined'" class="fas fa-circle c-m-gray"
             v-b-popover.hover.top="`${$tc('info.notDefinable', 1).toLowerCase()}`"
          ></i>
          <i v-if="row.item.infoStatus === 'Ok'"        class="fas fa-circle c-green"
             v-b-popover.hover.top="`${$tc('info.regular', 1).toLowerCase()}`"
          ></i>
          <i v-if="row.item.infoStatus === 'Warning'"   class="fas fa-circle c-yellow"
             v-b-popover.hover.top="`${$tc('info.runningOut', 1).toLowerCase()}`"
          ></i>
          <i v-if="row.item.infoStatus === 'Error'"     class="fas fa-circle c-red"
             v-b-popover.hover.top="`${$tc('info.exhaustedKm', 1).toLowerCase()}`"
          ></i>
        </div>

        <b-container slot="before-pagination" class="mw-100 p-0">
          <b-row align-v="center" class="mb-3">
            <b-col cols="12" sm="6" md="6" lg="3" xl="3">
              <i class="fas fa-circle c-m-gray" id="popover-gray"></i>
              {{$tc('info.notDefinable', 1)}}

              <b-popover target="popover-gray" triggers="hover" placement="top">
                <b> km {{$tc('message.actual', 1).toLowerCase()}}</b>
                {{$tc('message.or', 1).toLowerCase()}}
                <b> km {{$tc('message.rental', 1).toLowerCase()}} {{$tc('message.max', 2).toLowerCase()}}</b>
                {{$tc('message.missed', 2).toLowerCase()}}
              </b-popover>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="3" xl="3">
              <i class="fas fa-circle c-green" id="popover-green"></i>
              {{$tc('info.regular', 1)}}

              <b-popover target="popover-green" triggers="hover" placement="top">
                {{$t('info.vehicleRegularStatus')}}
              </b-popover>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="3" xl="3">
              <i class="fas fa-circle c-yellow" id="popover-yellow"></i>
              {{$tc('info.runningOut', 1) }}

              <b-popover target="popover-yellow" triggers="hover" placement="top">
                {{$tc('info.vehicleIsRunningOut', 1)}} ({{$tc('info.missingLessThan')}} {{threshold}} km)
              </b-popover>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="3" xl="3">
              <i class="fas fa-circle c-red" id="popover-red"></i>
              {{$tc('info.exhaustedKm', 1)}}

              <b-popover target="popover-red" triggers="hover" placement="top">
                {{$tc('info.vehicleRentalExhausted', 1)}}
              </b-popover>
            </b-col>
          </b-row>
        </b-container>

        <b-container slot="row-after-search" class="mw-100 p-0">
          <b-row>
            <b-col cols="auto">
              <b-button v-on:click="resetFilters()" class="b-c-green" id="reset-filters">
                {{$t('message.resetFilters')}}
              </b-button>
            </b-col>

            <b-col cols="auto" class="mb-3">
              <b-button @click="showCollapse = !showCollapse" :class="showCollapse ? 'b-c-red' : 'b-c-green'">
                <span v-show="!showCollapse" class="when-opened">{{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
                <span v-show="showCollapse" class="when-closed">{{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container :body-class="isMobile ? 'p-2' : ''" slot="after-search" class="mw-100 p-0">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group>
                    <label slot="label" class="m-0 p-0">
                      km {{$tc('message.remaining', 2)}}
                      (<i class="fas fa-info-circle fa-md c-green hover-enabled" @click="showInfoModal(true)"></i>)
                    </label>
                    <b-input-group append="km">
                      <b-form-input id="input-remaining-km"
                                    v-model="filterKm"
                                    autocomplete="off"
                                    :placeholder="`${$tc('message.example', 1)}: 1500`"
                                    type="number"
                                    min="1">
                      </b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group>
                    <label slot="label" class="m-0 p-0">
                      {{$tc('message.warningThreshold', 1)}}
                      (<i class="fas fa-info-circle fa-md c-green hover-enabled" @click="showInfoModal(false)"></i>)
                    </label>
                    <b-input-group append="km">
                      <b-form-input id="input-threshold"
                                    v-model="threshold"
                                    autocomplete="off"
                                    :placeholder="`${$tc('message.example', 1)}: 5000`"
                                    type="number"
                                    :max="filterKm"
                                    :state="filterKm && threshold ? (parseInt(filterKm) + 1) > parseInt(threshold) : true"
                                    min="1">
                      </b-form-input>
                    </b-input-group>
                  </b-form-group>

                  <div v-if="filterKm && threshold ? parseInt(threshold) > parseInt(filterKm) : false" class="my-invalid-feedback">
                    <h6>km {{$tc('message.remaining', 2).toLowerCase()}}
                      {{$tc('warnings.canNotBeBefore', 2).toLowerCase()}} {{$t('message.warningThreshold').toLowerCase()}}
                    </h6>
                  </div>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="$tc('message.status', 1)"
                                label-for="input-status">
                    <model-list-select id="input-status"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="statusOptions && statusOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="statusFilter"
                                       :list="statusOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.sector', 1)} ${$tc('message.activity', 1).toLowerCase()}`"
                                label-for="input-activity-sector">
                    <model-list-select id="input-activity-sector"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="activitySectorOptions && activitySectorOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="activitySectorFilter"
                                       :list="activitySectorOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="$tc('message.society', 1)"
                                label-for="input-corp">
                    <model-list-select id="input-corp"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="companyOptions && companyOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="companyFilter"
                                       :list="companyOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.property', 1)}`"
                                label-for="input-owner">
                    <model-list-select id="input-owner"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="ownerOptions && ownerOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="ownerFilter"
                                       :list="ownerOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$t('message.inOperation')}`"
                                label-for="input-removed">
                    <model-list-select id="input-removed"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="removedOptions && removedOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="removedFilter"
                                       :list="removedOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-container>

        <b-container :body-class="isMobile ? 'p-2' : ''" slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0" id="excel-button" @click="handleExcel($tc('message.vehicle', 2), getExcelFields())">Excel</b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>

    <b-modal ref="infoModal" id="infoModal" :title="`${$t('message.info')}`"
             size="lg"
             no-close-on-backdrop no-close-on-esc hide-header-close>
      <b-container v-if="isRemainingKmInfoModal">
        <b-row>
          {{$t('info.remainingKmInfo1')}}
        </b-row>

        <b-row class="d-block">
          {{$t('info.remainingKmInfo2')}} <b>km {{$tc('message.remaining', 2)}}</b>
          {{$t('info.remainingKmInfo3')}}
        </b-row>

        <b-row class="mt-3 d-block">
          {{$t('info.remainingKmInfo4')}} <b>{{$t('message.warningThreshold')}}</b>).
        </b-row>
      </b-container>

      <b-container v-else>
        <b-row class="d-block">
          {{$t('info.thresholdInfoModal1')}} <b>{{$t('message.warningThreshold')}}</b>
          {{$t('info.thresholdInfoModal2')}} <b>km {{$tc('message.remaining', 2)}}</b>)
          {{$t('info.thresholdInfoModal3')}}
        </b-row>

        <b-row class="mt-2">
          {{$t('info.thresholdInfoModal4')}}
        </b-row>

        <b-row class="mt-2 d-block">
          ES: <b>km {{$tc('message.remaining', 2)}}</b> = 30.000;
          <b>{{$t('message.warningThreshold')}}</b> = 2.500:
          {{$t('info.thresholdInfoModal5')}}
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button class="b-c-green" @click="$refs.infoModal.hide()"> Ok
        </b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { DateTime } from 'luxon'
import { filter, find, orderBy, cloneDeep } from 'lodash'

export default {
  name: 'ReportKmVehiclesHired',
  created () {
    this.fetchData()
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.fetchData()
      }
    })
    this.$root.$on('resize', () => {
      this.checkWindowWidth()
    })
  },
  data () {
    const config = this.$route.meta.config

    return {
      config,
      DateTime,
      isMobile: false,
      fields: [],
      customFields: [],
      originalItems: [],
      items: [],
      itemsList: [],
      // filters
      activitySectorOptions: [],
      activitySectorFilter: '',
      companyOptions: [],
      companyFilter: '',
      ownerOptions: [],
      ownerFilter: '',
      ownershipTypeOptions: [],
      statusOptions: [],
      statusFilter: '',
      removedOptions: [],
      removedFilter: '',
      // other options for excel
      showCollapse: false,
      filterKm: null,
      threshold: 5000,
      isRemainingKmInfoModal: true
    }
  },
  watch: {
    activitySectorFilter (val) {
      this.items = this.getItems(val, this.companyFilter, this.ownerFilter, this.filterKm, this.statusFilter, this.threshold, this.removedFilter)
    },
    companyFilter (val) {
      this.items = this.getItems(this.activitySectorFilter, val, this.ownerFilter, this.filterKm, this.statusFilter, this.threshold, this.removedFilter)
    },
    ownerFilter (val) {
      this.items = this.getItems(this.activitySectorFilter, this.companyFilter, val, this.filterKm, this.statusFilter, this.threshold, this.removedFilter)
    },
    filterKm (val) {
      if (val) this.threshold = null
      this.items = this.getItems(this.activitySectorFilter, this.companyFilter, this.ownerFilter, val, this.statusFilter, this.threshold, this.removedFilter)
    },
    statusFilter (val) {
      this.items = this.getItems(this.activitySectorFilter, this.companyFilter, this.ownerFilter, this.filterKm, val, this.threshold, this.removedFilter)
    },
    threshold (val) {
      this.items = this.getItems(this.activitySectorFilter, this.companyFilter, this.ownerFilter, this.filterKm, this.statusFilter, val, this.removedFilter)
    },
    removedFilter (val) {
      this.items = this.getItems(this.activitySectorFilter, this.companyFilter, this.ownerFilter, this.filterKm, this.statusFilter, this.threshold, val)
    }
  },
  methods: {
    getItems (activitySector, company, owner, filterKm, status, threshold, removed) {
      const ownershipType = 'rental'
      const originalItems = cloneDeep(this.originalItems)
      let editedItems = []
      originalItems.forEach(item => {
        const editedItem = this.getStatusData(item, threshold)
        editedItems.push(editedItem)
      })
      if (activitySector && activitySector !== '') {
        editedItems = filter(editedItems, obj => obj.activitySectorValue === find(this.activitySectorOptions, obj => obj.value === activitySector).value)
      }
      if (company && company !== '') {
        editedItems = filter(editedItems, obj => obj.userCompanyValue === find(this.companyOptions, obj => obj.value === company).value)
      }
      if (owner && owner !== '') {
        editedItems = filter(editedItems, obj => obj.propertyValue === find(this.ownerOptions, obj => obj.value === owner).value)
      }
      if (ownershipType) {
        editedItems = filter(editedItems, obj => obj.ownershipValue === find(this.ownershipTypeOptions, obj => obj.value === ownershipType).value)
      }
      if (filterKm) {
        editedItems = filter(editedItems, obj => obj.remainingKm && (obj.remainingKm <= filterKm || isNaN(obj.remainingKm)))
      }
      if (status && status !== '') {
        editedItems = filter(editedItems, obj => obj.infoStatus === status)
      }
      if (removed !== '') {
        editedItems = filter(editedItems, obj => obj.disabled === removed)
      }
      return editedItems
    },
    fetchData () {
      this.$root.$emit('activeLoader', true)
      return this.getOptions().then(() => this.getVehicle()).catch(r => {
        this.$root.$emit('activeLoader', false)
        return r
      })
    },
    checkWindowWidth () {
      const size = Vue.myGetWindowSize()
      this.isMobile = (size !== 'md' && size !== 'lg' && size !== 'xl')
    },
    getOptions () {
      const axiosArray = []
      this.getFields()
      this.getCustomFields()
      this.getOwnershipTypeOptions()
      this.getStatusOptions()
      this.getRemovedOptions()
      axiosArray.push(this.getEnum('owner', 'ownerOptions'))
      axiosArray.push(this.getEnum('company', 'companyOptions'))
      axiosArray.push(this.getEnum('activity_sector', 'activitySectorOptions'))
      return Vue.myAll(axiosArray).then(r => r)
    },
    getOwnershipTypeOptions () {
      this.ownershipTypeOptions = [
        { value: '', text: this.$t('message.selectOption') },
        { value: 'rental', text: this.$tc('message.rental', 1) },
        { value: 'leasing', text: 'Leasing' },
        { value: 'property', text: this.$tc('message.property', 1) },
        { value: 'loan', text: this.$tc('message.loan', 1) }
      ]
    },
    getStatusOptions () {
      this.statusOptions = [
        { value: '', text: this.$t('message.selectOption') },
        { value: 'Undefined', text: this.$tc('info.notDefinable', 1) },
        { value: 'Ok', text: this.$tc('info.regular', 1) },
        { value: 'Warning', text: this.$tc('info.runningOut', 1) },
        { value: 'Error', text: this.$tc('info.exhaustedKm', 2) }
      ]
    },
    getRemovedOptions () {
      this.removedOptions = [
        { value: '', text: this.$t('message.all') },
        { value: false, text: this.$t('message.yes') },
        { value: true, text: this.$t('message.no') }
      ]
    },
    getVehicle () {
      this.originalItems = []
      this.items = []

      return Vue.myGet(this, '/vehicles?all=true', 'vehicles').then((vehicles) => {
        const editedItems = []
        const activitySectorOptions = this.activitySectorOptions
        const ownerOptions = this.ownerOptions
        const companyOptions = this.companyOptions
        const ownershipTypeOptions = this.ownershipTypeOptions
        const options = {
          activitySectorOptions,
          ownerOptions,
          companyOptions,
          ownershipTypeOptions
        }
        vehicles.forEach(vehicle => {
          const editedVehicle = this.assembleVehicle(vehicle, options)
          if (editedVehicle.ownershipValue === 'rental') editedItems.push(editedVehicle)
        })
        this.originalItems = orderBy(editedItems, 'plateNumber')
        this.items = cloneDeep(this.originalItems)
        this.$root.$emit('activeLoader', false)
        return this.items
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    assembleVehicle (vehicle, options) {
      let newVehicle = this.getMainVehicleData(vehicle)
      newVehicle = this.getExtraData(vehicle, newVehicle, options)
      newVehicle = this.getVehicleUsage(vehicle, newVehicle, options)
      newVehicle = this.getStatusData(newVehicle, this.threshold)
      return newVehicle
    },
    getMainVehicleData (vehicle) {
      return {
        id: vehicle.id,
        plateNumber: vehicle.plateNumber,
        typeBrand: (vehicle.type && vehicle.type.brand) || '',
        typeModel: (vehicle.type && vehicle.type.model) || '',
        disabled: !!vehicle.disablingDate
      }
    },
    getExtraData (oldVehicle, vehicle, options) {
      const activitySector = find(options.activitySectorOptions, obj => obj.value === oldVehicle.activitySector && oldVehicle.activitySector !== null)
      const property = find(options.ownerOptions, obj => oldVehicle.ownership && obj.value === oldVehicle.ownership.owner && oldVehicle.ownership.owner !== null)
      const userCompany = find(options.companyOptions, obj => obj.value === oldVehicle.userCompany && oldVehicle.userCompany !== null)

      vehicle.property = property && property.text
      vehicle.propertyValue = property && property.value
      vehicle.userCompanyText = userCompany && userCompany.text
      vehicle.userCompanyValue = userCompany && userCompany.value
      vehicle.activitySectorText = activitySector && activitySector.text
      vehicle.activitySectorValue = activitySector && activitySector.value
      vehicle.automathicKm = oldVehicle.estimatedKm
      return cloneDeep(vehicle)
    },
    getVehicleUsage (oldVehicle, vehicle, options) {
      const ownershipObj = this.getOwnershipType(cloneDeep(oldVehicle.ownership), options)
      const rental = oldVehicle.ownership && oldVehicle.ownership.rental
      vehicle.ownership = ownershipObj && ownershipObj.name
      vehicle.ownershipValue = ownershipObj && ownershipObj.ownershipValue
      vehicle.rentalStart = rental && rental.startDate && rental.type !== 'loan' ? rental.startDate : this.$t('message.noDate')
      vehicle.rentalEnd = rental && rental.endDate && rental.type !== 'loan' ? rental.endDate : this.$t('message.noDate')
      vehicle.maxKm = rental && rental.maxKm
      return cloneDeep(vehicle)
    },
    getOwnershipType (ownership, options) {
      if (ownership) {
        let name = null
        const rentalType = ownership.rental && ownership.rental.type
        const rentalStart = ownership.rental && ownership.rental.startDate && DateTime.fromSQL(ownership.rental.startDate)
        const leasingStart = ownership.leasing && ownership.leasing.startDate && DateTime.fromSQL(ownership.leasing.startDate)
        const rentalEnd = ownership.rental && ownership.rental.endDate && DateTime.fromSQL(ownership.rental.endDate)
        const leasingEnd = ownership.leasing && ownership.leasing.endDate && DateTime.fromSQL(ownership.leasing.endDate)
        const purchaseStart = ownership.purchase && ownership.purchase.date && DateTime.fromSQL(ownership.purchase.date)
        let ownershipValue = null
        if (purchaseStart) name = this.$tc('message.property', 1)
        if (!name && rentalEnd > leasingEnd) name = rentalType === 'rental' ? this.$tc('message.rental', 1) : this.$t('message.loan')
        if (!name && leasingEnd > rentalEnd) name = 'Leasing'
        if (!name && leasingEnd) name = 'Leasing'
        if (!name && rentalEnd) name = rentalType === 'rental' ? this.$tc('message.rental', 1) : this.$t('message.loan')
        if (name) {
          ownershipValue = find(options.ownershipTypeOptions, obj => obj.text === name).value
        }
        return {
          ownershipValue,
          name,
          rentalStart,
          rentalEnd,
          leasingStart,
          leasingEnd,
          purchaseDate: purchaseStart
        }
      }
      return null
    },
    getStatusData (vehicle, threshold) {
      let remainingKm = null
      let status = 'Undefined'
      if (!!vehicle.automathicKm || (vehicle.automathicKm === 0 && !!vehicle.maxKm) || vehicle.maxKm === 0) {
        const newVal = vehicle.maxKm - vehicle.automathicKm
        if (!isNaN(newVal)) {
          remainingKm = newVal > 0 ? newVal : `${this.$t('message.exceededBy')}: ${newVal * -1}`
          if (newVal > 0 && newVal <= threshold) {
            status = 'Warning'
          } else if (newVal < 0) {
            status = 'Error'
          } else if (newVal > threshold) {
            status = 'Ok'
          }
        }
      }
      vehicle.remainingKm = remainingKm
      vehicle.infoStatus = status
      switch (status) {
        case 'Ok':
          vehicle.infoStatusText = this.$tc('info.regular', 1)
          break

        case 'Warning':
          vehicle.infoStatusText = this.$tc('info.runningOut', 1)
          break

        case 'Error':
          vehicle.infoStatusText = this.$tc('info.exhaustedKm', 2)
          break

        default:
          vehicle.infoStatusText = this.$tc('info.notDefinable', 1)
          break
      }
      return vehicle
    },
    resetFilters () {
      this.activitySectorFilter = ''
      this.companyFilter = ''
      this.ownerFilter = ''
      this.filterKm = ''
      this.threshold = 5000
      this.ownerFilter = ''
      this.statusFilter = ''
      this.removedFilter = ''
      this.$refs.vehicleTable.resetSearch()
    },
    getFields () {
      this.fields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '', hideInTable: !this.config.u && !this.config.r },
        { key: 'plateNumber', label: this.$tc('message.numberPlate', 1), sortable: true, sortDirection: 'desc' },
        { key: 'typeBrand', label: this.$t('message.brand'), sortable: true, sortDirection: 'desc' },
        { key: 'typeModel', label: this.$tc('message.model', 1), sortable: true, sortDirection: 'desc' },
        { key: 'activitySectorText', label: `${this.$tc('message.sector', 1)} ${this.$tc('message.activity', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'userCompanyText', label: this.$tc('message.society', 1), sortable: true, sortDirection: 'desc' },
        { key: 'property', label: this.$tc('message.property', 1), sortable: true, sortDirection: 'desc' },
        { key: 'automathicKm', label: `km ${this.$tc('message.actual', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'maxKm', label: `km ${this.$tc('message.rental', 1).toLowerCase()} ${this.$tc('message.max', 2).toLowerCase()} `, sortable: true, sortDirection: 'desc' },
        { key: 'remainingKm', label: `km ${this.$tc('message.remaining', 2).toLowerCase()}`, sortable: true, sortDirection: 'desc' }
      ]
    },
    getCustomFields () {
      this.customFields = [
        { key: 'test', label: this.$tc('message.status', 1) }
      ]
    },
    pushToEdit (item) {
      this.$router.push({
        name: 'EditVehicle', params: { id: item.id }, query: { tab: 'use' }
      })
    },
    getExcelFields () {
      return [
        { key: 'plateNumber', label: this.$tc('message.numberPlate', 1), sortable: true, sortDirection: 'desc' },
        { key: 'typeBrand', label: this.$t('message.brand'), sortable: true, sortDirection: 'desc' },
        { key: 'typeModel', label: this.$tc('message.model', 1), sortable: true, sortDirection: 'desc' },
        { key: 'activitySectorText', label: `${this.$tc('message.sector', 1)} ${this.$tc('message.activity', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'userCompanyText', label: this.$tc('message.society', 1), sortable: true, sortDirection: 'desc' },
        { key: 'property', label: this.$tc('message.property', 1), sortable: true, sortDirection: 'desc' },
        { key: 'automathicKm', label: `km ${this.$tc('message.actual', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'maxKm', label: `km ${this.$tc('message.rental', 1).toLowerCase()} ${this.$tc('message.max', 2).toLowerCase()} `, sortable: true, sortDirection: 'desc' },
        { key: 'remainingKm', label: `km ${this.$tc('message.remaining', 2).toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'infoStatusText', label: this.$tc('message.status', 1), hideInTable: true }
      ]
    },
    getEnum (path, obj) {
      const options = []

      return Vue.myGet(this, `/enums/${path}`, 'data').then((items) => {
        options.push({ value: '', text: items.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption') })
        items.forEach((item) => {
          options.push({ value: item.id, text: item.descr })
        })
        if (obj) {
          this[obj] = options
        }
        return options
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    handleExcel (fileName, fields) {
      return this.$refs.vehicleTable.excel(fileName, fields)
    },
    showInfoModal (isRemainingKmInfoModal) {
      this.isRemainingKmInfoModal = isRemainingKmInfoModal
      this.$refs.infoModal.show()
    }
  }
}
</script>

<style scoped>

</style>
